export const STATUS_REQUEST = "shipping_delivery_status_1";
export const STATUS_CONFIRMED = "shipping_delivery_status_2";

export const SETTLEMENT_PENDING = "pending";
export const SETTLEMENT_COMPLETE = "completed";

export const STATUS_ONSALE = "shipping_sale_status_1";
export const STATUS_SOLDOUT = "shipping_sale_status_2";
export const STATUS_EXPORT_COMPLETE = "shipping_sale_status_3";
